import { GUIGameState } from '../../types/game-types';
import { useDungeonCrawlerStore } from '../zustand/useDungeonCrawlerStore';

/**
 * Decrements dungeon cooldown by 1 each tick (tick = 1 second).
 * Cooldown lives in useDungeonCrawlerStore only (not on GUIGameState).
 */
export const manageDungeonCooldownReducer = (state: GUIGameState): GUIGameState => {
  useDungeonCrawlerStore.getState().tickCooldown();
  return state;
};
